import React, { useState } from "react";
import { Modal, Row, Col, Image } from "antd";
import "./Gallery.css";

// ✅ Import all 30 images
import Image1 from "../../GalleryImages/image1.jpeg";
import Image2 from "../../GalleryImages/image2.jpeg";
//import Image3 from "../../GalleryImages/image3.jpeg";
import Image4 from "../../GalleryImages/image4.jpeg";
import Image5 from "../../GalleryImages/image5.jpeg";
import Image6 from "../../GalleryImages/image6.jpeg";
import Image7 from "../../GalleryImages/image7.jpeg";
import Image8 from "../../GalleryImages/image8.jpeg";
import Image9 from "../../GalleryImages/image9.jpeg";
import Image10 from "../../GalleryImages/image10.jpeg";
import Image11 from "../../GalleryImages/image11.jpeg";
// import Image12 from "../../GalleryImages/image12.jpeg";
import Image13 from "../../GalleryImages/image13.jpeg";
import Image14 from "../../GalleryImages/image14.jpeg";
// import Image15 from "../../GalleryImages/image15.jpeg";
import Image16 from "../../GalleryImages/image16.jpeg";
import Image17 from "../../GalleryImages/image17.jpeg";
import Image18 from "../../GalleryImages/image18.jpeg";
import Image19 from "../../GalleryImages/image19.jpeg";
import Image20 from "../../GalleryImages/image20.jpeg";
import Image21 from "../../GalleryImages/image21.jpeg";
import Image22 from "../../GalleryImages/image22.jpeg";
import Image23 from "../../GalleryImages/image23.jpeg";
import Image24 from "../../GalleryImages/image24.jpeg";
import Image25 from "../../GalleryImages/image25.jpeg";
import Image26 from "../../GalleryImages/image26.jpeg";
import Image27 from "../../GalleryImages/image27.jpeg";
import Image28 from "../../GalleryImages/image28.jpeg";
import Image29 from "../../GalleryImages/image29.jpeg";
import Image30 from "../../GalleryImages/image30.jpg";

const images = [
  Image1, Image2, Image4, Image5,
  Image6, Image7, Image8, Image9, Image10,
  Image11, Image13, Image14,
  Image16, Image17, Image18, Image19, Image20,
  Image21, Image22, Image23, Image24, Image25,
  Image26, Image27, Image28, Image29, Image30
];

const Gallery = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);

  const openModal = (imgSrc) => {
    setCurrentImage(imgSrc);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentImage(null);
  };

  return (
    <div className="gallery-container">
      {/* ✅ Elegant Header */}
      <div className="gallery-header">
        <h1 className="gallery-title">Our Gallery</h1>
        <p className="gallery-subtitle">
          A visual journey through our proudest creations — crafted with passion, precision, and purpose.
        </p>
      </div>

      {/* ✅ Responsive Image Grid */}
      <Row gutter={[16, 16]} justify="center">
        {images.map((src, index) => (
          <Col key={index} xs={12} sm={8} md={6} lg={4}>
            <div className="gallery-item" onClick={() => openModal(src)}>
              <Image
                src={src}
                alt={`Gallery image ${index + 1}`}
                preview={false}
                className="gallery-image"
              />
            </div>
          </Col>
        ))}
      </Row>

      {/* ✅ Clean Modal without dark background */}
      <Modal
        open={isModalOpen}
        footer={null}
        onCancel={closeModal}
        centered
        width="auto"
        mask={false}  // 🔥 removes dark overlay
        styles={{
          content: {
            background: "transparent",
            boxShadow: "none",
            border: "none",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
          body: {
            padding: 0,
            margin: 0,
          },
        }}
        className="gallery-modal"
      >
        {currentImage && (
          <img
            src={currentImage}
            alt="Preview"
            className="modal-image"
            onClick={closeModal}
          />
        )}
      </Modal>
    </div>
  );
};

export default Gallery;
